import App from "@frog/source/models/App.js"
import Director from "@frog/source/juice/Director.js"
import pixel from "@frog/source/views/app/stage/utility/pixel.js"
import Geometry from "@frog/source/utility/Geometry.js"
import * as Objdict from "objdict"

import Skills from "@frog/source/data/skills.js"
import World from "@frog/source/models/World.js"
import Colors from "@frog/source/data/colors.js"
import {isInDanger} from "@frog/source/data/deathzone.js"

export default function Dangerzones(stage) {
    return [
        BombZones(stage),
        // DeathfogZones(stage),
    ]
}

function BombZones(stage) {
    const views = []
    if(Director.isPerforming) return
    // Render the dangerzone predictively if it
    // will be pushed by the player's hovered action.
    if(App.game.encounter != undefined
    && App.game.encounter.selection != undefined
    && App.game.encounter.selection.hoveredAction != undefined
    && App.game.encounter.selection.hoveredAction.omegastage != undefined) {
        stage = App.game.encounter.selection.hoveredAction.omegastage
    }
    if(stage.nextTurn != undefined) {
        stage.nextTurn.steps.forEach((step) => {
            if(step.type == "invoke skill"
            && step.skillKey == "explode") {
                step.deltastages.forEach((deltastage) => {
                    if(deltastage.annotation.type == "explode") {
                        const position = deltastage.annotation.position
                        const unitKey = deltastage.annotation.performerKey
                        views.push({
                            "key": "dangerzone/bomb/" + unitKey + "/" + position.x + "x" + position.y,
                            "image": require("@frog/source/assets/images/bomber-tactics/attack-tile-threat.png").default,
                            // "opacity": unitKey == App.game.encounter.selection.activeUnitKey ? 0.8 : 0.75,
                            // "tint": {"color": Colors.red, "intensity": 1},
                            "position": pixel("range2", {
                                "x": position.x,
                                "y": position.y,
                                "z": position.z,
                            }),
                        })
                    }
                })
            }
        })
    }
    return views
}

const points = [
    {"x": -0.5, "y": -0.5},
    {"x": -0.5, "y": +0.5},
    {"x": +0.5, "y": -0.5},
    {"x": +0.5, "y": +0.5},
]

function DeathfogZones(stage) {
    const views = []
    for(let x = 0; x < stage.world.width; x += 1) {
        for(let y = 0; y < stage.world.height; y += 1) {
            if(isInDanger(stage, {x, y}, stage.zone) == true) {

                const position = {"x": x - 0.5, "y": y - 0.5 - 0.5}
                position.stack = 1000000
                views.push({
                    "type": "rectangle",
                    "key": "fog/" + x + "x" + y,
                    "position": pixel("fog", position),
                    "color": 0xFFFFFF,
                    "width": 8,
                    "height": 8,
                })
                // points.forEach((point, index) => {
                //     // if(isInDanger(stage, {x, y}, stage.zone + 1) == true) {
                //     //     points.forEach((point, index) => {
                //     //         const position = Geometry.add({"x": x, "y": y - 0.5}, point)
                //     //         position.stack = 1000000
                //     //         views.push({
                //     //             "type": "graphic",
                //     //             "key": "fog/" + x + "x" + y + "/" + index,
                //     //             "position": pixel("fog", position),
                //     //             "color": 0xFFFFFF,
                //     //             "radius": 4,
                //     //         })
                //     //     })
                //     // } else {
                //     // }
                // })
            }
            // if(isInDanger(stage, {x, y}, stage.zone) == false
            // && isInDanger(stage, {x, y}, stage.zone + 1) == true) {
            //     views.push({
            //         "key": "dangerzone/fog/" + x + "x" + y,
            //         "position": pixel("range2", {x, y, "z": 0}),
            //         "image": require("@frog/source/assets/images/bomber-tactics/tile-threat.png"),
            //         "tint": {"color": Colors.red},
            //     })
            // }
        }
    }
    return views
}
